import { ContentLibraryState } from 'features/content-library/types';

type RevealCandidate = {
  id: string;
  name: string;
  parentFolderId: string;
  personal: boolean;
};

const reveal = (state: ContentLibraryState, id: string) => {
  state.revealItemId = id;
  state.pendingReveal = null;
};

export const promoteRevealById = (state: ContentLibraryState, id: string) => {
  const nomination = state.pendingReveal;

  if (nomination && 'id' in nomination && nomination.id === id) {
    reveal(state, id);
  }
};

export const promoteRevealByLocation = (state: ContentLibraryState, candidate: RevealCandidate) => {
  const nomination = state.pendingReveal;

  if (!nomination || 'id' in nomination) {
    return;
  }

  if (
    nomination.name === candidate.name &&
    nomination.parentFolderId === candidate.parentFolderId &&
    nomination.personal === candidate.personal
  ) {
    reveal(state, candidate.id);
  }
};
